import { useState } from 'react';

export const getStorageValue = <T>(key: string, defaultValue: T) => {
  // getting stored value
  const saved = localStorage.getItem(`@powerprotection:${key}`);
  const initial = JSON.parse(saved!);
  return initial || defaultValue;
};

export const clearStorageValue = (key: string) => {
  // clearing stored value
  if (typeof window !== 'undefined') {
    window.localStorage.removeItem(`@powerprotection:${key}`);
  }
};

export const useLocalStorage = <T>(key: string, initialValue: T) => {
  // State to store our value
  // Pass initial state function to useState so logic is only executed once
  const [storedValue, setStoredValue] = useState(() => {
    if (typeof window === 'undefined') {
      return initialValue;
    }

    try {
      // Get from local storage by key
      const item = window.localStorage.getItem(`@powerprotection:${key}`);
      // Parse stored json or if none return initialValue
      return item ? JSON.parse(item) : initialValue;
    } catch (error) {
      // If error also return initialValue
      console.log(error);
      return initialValue;
    }
  });
  // Return a wrapped version of useState's setter function that ...
  // ... persists the new value to localStorage.
  const setValue = (value: T | ((val: T) => T)) => {
    try {
      // Allow value to be a function so we have same API as useState
      const valueToStore = value instanceof Function ? value(storedValue) : value;
      // Save state
      setStoredValue(valueToStore);
      // Save to local storage
      if (typeof window !== 'undefined') {
        window.localStorage.setItem(`@powerprotection:${key}`, JSON.stringify(valueToStore));
      }
    } catch (error) {
      // A more advanced implementation would handle the error case
      console.log(error);
    }
  };

  return [storedValue, setValue] as const;
};
